import { useDispatch, useSelector } from "react-redux";
import { selectAccount, updateAccount } from "app/redux/accountSlice";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import {uploadFile} from "../../utils/upload";

export const useBranding = () => {
  const dispatch = useDispatch();
  const account = useSelector(selectAccount);

  const [logoPreview, setLogoPreview] = useState<string | null>(null);
  const [landingImagesPreview, setLandingImagesPreview] = useState<string|null>(null);
  const [logoUploading, setLogoUploading] = useState(false)
  const [landingImageUploading, setLandingImageUploading] = useState(false)

  // Initialize the previews based on account data
  useEffect(() => {
    if (account) {
      setLogoPreview(account.logo);
    }
    if (account?.selectedLandingImageLink) {

      setLandingImagesPreview(account?.selectedLandingImageLink);
    }
  }, [account]);

  const handleLogoChange = async (
      event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const input = event.target;
    const file = input.files?.[0];

    if (!file) {
      toast.error("No file to upload");
      return;
    }

    setLogoUploading(true);

    try {
      // Clear preview first
      setLogoPreview(null);

      // Temporary preview
      const previewUrl = URL.createObjectURL(file);
      setLogoPreview(previewUrl);

      const url = await handleLogoUpload(file);

      if (url) {
        await dispatch(updateAccount({ logo: url }) as any).unwrap();
        toast.success("Logo updated successfully");
      } else {
        toast.error("Failed to upload logo");
      }
    } catch (error: any) {
      console.error("Error updating logo:", error);
      toast.error("Failed to update logo");
    } finally {
      setLogoUploading(false);

      // 🔑 THIS IS THE KEY LINE
      input.value = "";
    }
  };


  const handleLandingImageChange = async (
      event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const input = event.target;
    const file = input.files?.[0];

    if (!file) {
      toast.error("No file to upload");
      return;
    }

    setLandingImageUploading(true);

    try {
      // Revoke old preview (important)
      if (landingImagesPreview) {
        URL.revokeObjectURL(landingImagesPreview);
      }

      // Show temporary preview
      const previewUrl = URL.createObjectURL(file);
      setLandingImagesPreview(previewUrl);

      const url = await handleLogoUpload(file);

      if (!url) {
        throw new Error("Upload failed");
      }

      await dispatch(
          updateAccount({ selectedLandingImageLink: url }) as any
      ).unwrap();

      toast.success("Landing image updated successfully");
    } catch (error: any) {
      console.error(
          "Error updating landing image:",
          error?.response || error?.message || error
      );
      toast.error("Failed to update landing image");
    } finally {
      // 🔑 Reset states & input so same file can be uploaded again
      setLandingImageUploading(false);
      input.value = "";
    }
  };


  const removeLogo=async ()=>{
    setLogoUploading(true)
    try {
      await dispatch(updateAccount({ logo: null }) as any).unwrap();
      setLogoUploading(false)
      setLogoPreview(null)
      toast.success("Logo Removed successfully");
    }
    catch (e) {
      setLogoUploading(false)
      toast.error("Logo Removed Failed");
    }

  }
  const removeLandingImage=async ()=>{
    setLandingImageUploading(true)
    try {
      await dispatch(updateAccount({ selectedLandingImageLink: '' }) as any).unwrap();
      setLandingImageUploading(false)
      setLandingImagesPreview(null)
      toast.success("Landing image Removed successfully");
    }
    catch (e) {
      setLandingImageUploading(false)
      toast.error("Landing Image Removed Failed");
    }

  }

  const handleLogoUpload = async (
        // event: React.ChangeEvent<HTMLInputElement>
        file: File
    ) => {
    const imageUrl = await uploadFile(file, "merchant/logo");
   return (imageUrl as any).url
  };


  //
  //
  // const handleLandingImagesChange = async (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   const files = event.target.files;
  //   if (files) {
  //     const newFiles = Array.from(files);
  //
  //     // Create previews for the new images
  //     const preview = newFiles.map((file) => URL.createObjectURL(file));
  //     setLandingImagesPreviews((prev) => [...prev, ...previews]);
  //
  //     try {
  //       // Send only the new files to the backend
  //       await dispatch(
  //         updateAccount({ landingImages: newFiles }) as any
  //       ).unwrap();
  //       toast.success("Landing images updated successfully");
  //     } catch (error: any) {
  //       console.error(
  //         "Error updating landing images:",
  //         error.response || error.message || error
  //       );
  //       toast.error("Failed to update landing images");
  //     }
  //   }
  // };

  const saveSelectedImage = async (link: string) => {
    try {
      await dispatch(
        updateAccount({
          selectedLandingImageLink: link,
        }) as any
      ).unwrap();
      toast.success("Selected image saved successfully");
    } catch (error: any) {
      console.error(
        "Error saving selected image:",
        error.response || error.message || error
      );
      toast.error("Failed to save selected image");
    }
  };

  useEffect(() => {
    return () => {
      // Revoke object URLs to avoid memory leaks
      if (logoPreview) URL.revokeObjectURL(logoPreview);
      if (landingImagesPreview) URL.revokeObjectURL(landingImagesPreview);
    };
  }, [logoPreview, landingImagesPreview]);

  return {
    logoPreview,
    landingImagesPreview,
    handleLogoChange,

    saveSelectedImage,
    account,handleLogoUpload,
    handleLandingImageChange,
    logoUploading,
    removeLogo,
    landingImageUploading,
    setLandingImageUploading,
    removeLandingImage
  };
};
